import http from '@/helpers/Http';

export default {
    namespaced: true,
    state: {
        items: {
            data: [],
            links: {},
            meta: {},
            gateways: [],
            groups: [],
        },
        selected: {},
    },
    getters: {
        items: state => state.items,
        selected: state => state.selected,
    },
    mutations: {
        setItems(state, items) {
            state.items = items;
        },
        setSelected(state, selected) {
            state.selected = selected;
        }
    },
    actions: {
        async index({ commit, rootState }) {
            const response = await http.get('sip/rules', {
                params: rootState.route.query
            });

            commit('setItems', response.data);

            return response;
        },
        async store({ commit }, payload) {
            const response = await http.post('sip/rules', payload);

            return response;
        },
        async update({ commit, state }, payload) {
            const response = await http.patch(`sip/rules/${state.selected.ruleid}`, payload);

            return response;
        },
        async delete({ commit, state }) {
            const response = await http.delete(`sip/rules/${state.selected.ruleid}`);

            return response;
        },
        async clone({ state }) {
            const response = await http.post(`sip/rules/${state.selected.ruleid}/clone`);

            return response;
        }
    }
}